import { ProjectStakeholderDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectStakeholderService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getProjectStakeholder(): Observable<ProjectStakeholderDto[]> {
    return this.http.get<ProjectStakeholderDto[]>(
      this.url + 'project-stakeholder'
    );
  }

  createProjectStakeholder(
    data: ProjectStakeholderDto[]
  ): Observable<ProjectStakeholderDto[]> {
    return this.http.post<ProjectStakeholderDto[]>(
      this.url + 'project-stakeholder',
      data
    );
  }
  getSingleProjectStakeholder(id: string): Observable<any> {
    return this.http.get(this.url + 'project-stakeholder/' + id);
  }

  updateProjectStakeholder(
    data: ProjectStakeholderDto[]
  ): Observable<ProjectStakeholderDto[]> {
    return this.http.post<ProjectStakeholderDto[]>(
      this.url + 'project-stakeholder/update',
      data
    );
  }

  deleteProjectStakeholder(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('project-stakeholder', ids.join(', '));
    return this.http.delete(this.url + 'project-stakeholder', httpOptions);
  }
}
